/**
 * Types of Validation Messages
 * @enum
 */
// disabling this eslint because of pipeline issues. Please use your local eslint to check the code.
/* eslint-disable quotes */
const Validation: { [key: string]: string } = {
  EMAIL_REQUIRED: 'Email is required.',
  EMAIL_VALID: 'Please enter a valid email address.',
  FIRST_NAME_REQUIRED: 'First name is required.',
  FIRST_NAME_VALID: 'First name is invalid.',
  LAST_NAME_REQUIRED: 'Last name is required.',
  LAST_NAME_VALID: 'Last name is invalid.',
  RENEWAL_REQUIRED: 'Renewal option is required.',

  ACCOUNT_NUMBER: 'Please enter a valid account number.',
  ACCOUNT_NUMBER_TEN_DIGITS: 'Please enter a valid 10 digit account number.',
  ACCOUNT_NUMBER_NOT_FOUND: 'Account not found, please try another account number.',

  NO_CONTENT: 'No content',
  CONTENT_ERROR: 'Oops! There was an error. Please try again later or report this issue.',
  FILTER_CARDS: 'Apply filter to view cards list.',
  FILTER_TRANSACTIONS: 'Apply filter to view transactions list.',

  MAX_CHAR_TEN: 'Must be less than 10 digits.',
  MAX_CHAR_TWELVE: 'Must be less than 12 characters.',
  MAX_CHAR_SIXTEEN: 'Must be less than 16 characters.',
  MAX_CHAR_NINETEEN: 'Must be less than 19 characters.',
  MAX_CHAR_TWENTY: 'Must be less than 20 characters.',
  MAX_CHAR_TWENTY_FOUR: 'Must be less than 24 characters.',
  MAX_CHAR_TWENTY_SEVEN: 'Must be less than 27 characters.',
  MAX_CHAR_THIRTY: 'Must be less than 30 characters.',
  MAX_CHAR_THIRTY_SIX: 'Must be less than 36 characters.',
  MAX_CHAR_FORTY: 'Must be less than 40 characters.',
  MAX_CHAR_FIFTY: 'Must be less than 50 characters.',
  MAX_CHAR_SIXTY_FOUR: 'Must be less than 64 characters.',
  MAX_CHAR_ONE_HUNDRED: 'Must be less than 100 characters',
  MAX_CHAR_TWO_FIFTY_FIVE: 'Must be less than 255 characters.',
  MAX_CHAR_THREE_HUNDRED: 'Must be less than 300 characters.',

  EXACT_DIGITS_SIXTEEN: 'Must be exactly 16 digits.',
  MIN_MAX_CHAR_SIXTEEN: 'Must be 16 digits.',

  EMBOSSING_NAME_REQUIRED: 'Embossing name is required.',
  EMBOSSING_LINE_2_REQUIRED: 'Embossing line 2 is required.',
  EXPIRY_DATE_REQUIRED: 'Expiry date is required.',
  VEHICLE_DESCRIPTION_REQUIRED: 'Vehicle description is required.',
  REGISTRATION_NUMBER_REQUIRED: 'Vehicle registration is required.',
  REGISTRATION_STATE_REQUIRED: 'Registration state is required.',
  CARD_FAV_NAME_REQUIRED: 'Card favourite name is required.',
  VEHICLE_TYPE_REQUIRED: 'Vehicle type is required.',
  FLEET_LIMITERS_REQUIRED: 'Please select at least one product or service.',
  DELIVERY_TYPE_REQUIRED: 'Delivery type is required.',
  START_DATE_REQUIRED: 'Start date is required.',
  END_DATE_REQUIRED: 'End date is required.',
  STATUS_REQUIRED: 'Status is required.',

  ADDRESS_REQUIRED: ' Address is required.',
  ADDRESS_LINE_2_REQUIRED: 'Address line 2 is required.',
  CITY_REQUIRED: 'City is required.',
  POSTCODE_REQUIRED: 'Postcode is required.',
  STATE_REQUIRED: 'State is required.',
  POSTCODE: 'Please enter 4 digits only.',
  SUBURB_REQUIRED: 'Suburb is required.',

  ALPHA: 'Please enter only alphabetical.',
  ALPHA_SPACE: 'Please enter only alphabet and space.',
  ALPHA_SPACE_HYPHEN: 'Please enter only alphabetical, space and hyphen.',
  ALPHA_NUM_SPACE_SPECIAL: "Please enter only alphanumeric, space, -, &, ', / and \\.",
  ALPHA_NUM_SPACE_SPECIAL2: "Please enter only alphanumeric, space, -, &, ' and /.",

  ALPHA_NUM: 'Please enter only alphanumeric.',
  ALPHA_NUM_SPACE: 'Please enter only alphanumeric and space.',
  ALPHA_NUM_SPECIAL_CHARACTER: 'Please enter your valid name.',
  ALPHA_NUM_SPACE_HYPHEN: 'Please enter only alphanumeric, space and hyphen (-).',
  EXPIRY_DATE_MONTH_YEAR: 'Please enter expiry date in format MM/YY.',
  CARD_FAV_NAME_UNIQUE: 'Card favourite name already exists.',

  ONLY_NUMBERS: 'Please enter numeric only.',
  CURRENCY: 'Please enter a valid numeric amount (e.g., 100, 100.00, 1000, or 100000).',
  MIN_CURRENCY_ONE: 'Amount must be greater or equal to $1.',

  AMOUNT_REQUIRED: 'Amount is required.',
  TERMS_AND_CONDITIONS_REQUIRED: 'Terms and conditions must be accepted.',

  DRIVER_NAME: "Please enter only alphanumeric, space and special characters . ( ) - & ' / and \\",

  LOCATION_NUMBER: "Must be '000' followed by 5 digits.",

  // FILTERS
  ACCOUNT_OR_CARD_NUMBER_REQUIRED: 'Account number or card number is required.',
  ISSUE_DATE_TO_AFTER_FROM: 'Issue date to must be after issue date from.',
  END_DATE_AFTER_START: 'End date must be after start date.',
  INVOICE_DATE_FROM_REQUIRED: 'Invoice date from is required.',
  INVOICE_DATE_TO_REQUIRED: 'Invoice date to is required.',
  INVOICE_DATE_TO_AFTER_FROM: 'Invoice date to must be after invoice date from.',
  MONTH_TO_DATE_CARD_LIMIT_REQUIRED: 'Month to date card limit is required.',

  // REPORTS
  DATE_FROM_REQUIRED: 'Processed date from is required.',
  DATE_TO_REQUIRED: 'Processed date to is required.',
  DATE_TO_AFTER_FROM: 'Processed date to must be after processed date from.',
  DATE_BEFORE_TODAY: 'Must not be after today.',

  CARD_RENEWAL_PERIOD_REQUIRED: 'Card renewal period is required.',
  REPORTING_DAY_OF_WEEK_REQUIRED: 'Reporting day of week is required.',

  MAX_DIGITS_THREE: 'Please enter a maximum of 3 digits only.',
  MAX_DIGITS_SIX: 'Please enter a maximum of 6 digits only.',

  EMAIL_TO_REQUIRED: 'Email to is required.',
  THREE_VALID_EMAILS: 'Please enter up to 3 valid email addresses separated by commas.',
  EMAIL_SUBJECT_REQUIRED: 'Email subject is required.',

  REPORTS_ALPHA_NUM_SPACE_SPECIAL:
    "Please enter only alphanumeric, space and special characters . , : ; ! ? ' $ & ( ).",
  REPORTS_LOCATION_NUMBER:
    "Please enter only 8-digit location numbers, each starting with '000' and separated by commas (e.g., 00012345, 00054321, ...).",

  SELECT_REPORTS_ACCOUNT: 'Select account to view existing report information.',
  SELECT_PENDING_TRANSFERS_ACCOUNT: 'Select an account above to see pending transfers for that account',

  // TRANSFER CARD FORM

  TOP_LEVEL_ACC_REQUIRED: 'Top level account is required.',
  TARGET_ACC_REQUIRED: 'Target account is required.',
  UNIQUE_TARGET_ACC: 'The target account cannot be the same as the source account. Please select a different account.',
  TRANSFER_DATE_REQUIRED: 'Transfer date is required.',
  MIN_ADD_TRANSFER_DATE: 'Must not be in the past.',
  MIN_EDIT_TRANSFER_DATE: 'Must be greater than the current date.',
  MAX_TRANSFER_DATE: "Must be within 60 days from today's date.",

  // UPDATE PIN

  PIN_REQUIRED: 'PIN is required.',
  CONFIRM_PIN: "The 'New PIN' and 'Confirm PIN' values do not match.",
  MIN_FOUR_MAX_SIX: 'Must be at least 4 and at most 6 digits.',

  // SCHEDULED MAINTENANCE

  TITLE_REQUIRED: 'Title is required.',
  MESSAGE_REQUIRED: 'Message is required.',
  SCHEDULED_MAINTENANCE_ALPHA_NUM_SPACE_SPECIAL:
    "Please enter only alphanumeric, space, and special characters & / \\ ' , . : * ( ) -",

  // PLASTIC TYPE

  PLASTIC_ID_REQUIRED: 'Plastic type id is required.',
  SHORT_NAME_REQUIRED: 'Short name is required.',
  DESCRIPTION_REQUIRED: 'Description is required.',
  CARD_MAINTENANCE_ALPHA_NUM_SPACE_SPECIAL:
    'Please enter only alphanumeric characters, space, and the special characters : & _ $',
  PLASTIC_ID: 'Please enter an id in the format A_### or C_###, where ### represents three numeric digits.',
  CARD_IMAGE_REQUIRED: 'Card image is required.',

  // ADDRESS FORM

  MOBILE: "Mobile number should start with '+614' followed by 8 numeric digits.",
  MOBILE_LANDLINE: "Phone number should start with '+614', '02,', '03,', '07,' or '08' followed by 8 numeric digits.",
  MULTIPLE_VALID_EMAILS_SEMICOLON: 'Please enter valid email addresses, separated by semi-colons (;).',

  // AMPOLCASH

  CUSTOM_MESSAGE:
    'Please enter only alphanumeric characters, spaces, and the following special characters: . , : ; ! ? \' " $ & ( ) -',
  QUANTITY_MSG_REQUIRED: 'Quantity is required.',
  INTEGER: 'Must be an integer.',
  MEDIA_TYPE_REQUIRED: 'Please select media type',
  DENOMINATION_REQUIRED: 'Please enter a denomination',
  DENOMINATION_MIN: 'Denomination must be at least 1',
  DENOMINATION_MAX: 'Denomination must not be greater than 4500',
  DENOMINATION_CODE_REQUIRED: 'Please select a denomination.',
  EXPIRY_DATE_RANGE: 'Must be within 1 to 99 months.',

  DISCOUNT: 'Please enter a valid discount with up to 2 decimal places.',
  DISCOUNT_MIN: 'Discount must be greater than or equal to 0',
  DISCOUNT_MAX: 'Discount must be less than or equal to 100',

  REQUESTOR_NAME: 'Requestor name is required.',
  REQUESTOR_PHONE: 'Requestor phone is required.',
  CASE_NUMBER: 'Case number is required.',

  CASH_DATE_FROM_REQUIRED: 'Date from is required.',
  CASH_DATE_TO_REQUIRED: 'Date to is required.',
  CASH_DATE_TO_AFTER_DATE_FROM: 'Date to cannot be before date from.',

  ORDER_VALUE_MIN: 'Order value cannot be less than 0.',
  ORDER_VALUE_MAX: 'Order value cannot exceed $999 999.',
  ORDER_VALUE_TO_GREATER_FROM: 'Order value to cannot be less than order value from.',
  ORDER_VALUE: 'Please enter a valid number, optionally with up to two decimal places.',

  VALID_CARD_OR_ORDER: 'Please enter a valid Order or Card Number.',

  QUANTITY_MAX: 'Maximum of 4000',
};
/* eslint-enable quotes */

export default Validation;
